import React, { useCallback, useMemo } from "react";
import { useLocation } from "react-router-dom";
import useCustomNavigate from "../../common_nextgen/common_components/Navigation/NextGenNavigation";
import NoteTable from "../../common_nextgen/common_components/NoteScreenComponents/NoteTable";
import NextGenPaginator from "../../common_nextgen/common_components/Pagination/NextGenPaginator";
import ButtonsSection from "../../common_nextgen/common_components/SearchScreenComponents/ButtonsSection";
import { ROUTE_PATHS } from "../../common_nextgen/utils/Constants.js";
import useAdditionalPatientPayNotes from "./hooks/useAdditionalPatientPayNotes.js";

const AdditionalPatientPayNotes = () => {
  const location = useLocation();
  const { state: stateVal } = location;
  const [currentState = {}] = [...stateVal].reverse();
  const previousState = [...stateVal];
  previousState.splice(stateVal.length - 1, 1);
  const {
    selectedAdditionalPatients = [],
    previousScreen = ROUTE_PATHS.ADDITIONAL_PATIENT_PAY,
    currentIndex: initialIndex = 0,
  } = currentState;
  console.log(
    "states",
    stateVal,
    currentState,
    selectedAdditionalPatients,
    initialIndex,
    previousState
  );
  const navigateToPage = useCustomNavigate();

  const {
    notes,
    newNotes,
    mode,
    first,
    rows,
    totalRecords,
    currentIndex,
    setMode,
    setFirst,
    setRows,
    setCurrentIndex,
    handleSaveNotes,
    handleChangeNewNote,
    onPageChange,
    exportAsCSV,
  } = useAdditionalPatientPayNotes(selectedAdditionalPatients, initialIndex);

  const screen_title = "Additional Patient Pay Notes";
  const screen_code = "RCAPN001";

  const columns =
    mode === "view"
      ? [
          { key: "apnNotes", header: "Note" },
          { key: "chgDate", header: "Added Date" },
          { key: "chgTime", header: "Added Time" },
          { key: "chgUserName", header: "User" },
        ]
      : [{ key: "apnNotes", header: "Note" }];

  const handleBack = useCallback(() => {
    if (currentIndex < selectedAdditionalPatients.length - 1) {
      setCurrentIndex(currentIndex + 1);
    } else {
      navigateToPage(previousScreen, previousState);
    }
  }, [currentIndex, navigateToPage, setCurrentIndex]);

  const handleBackAndSetMode = useCallback(() => {
    handleBack();
    setMode("view");
  }, [handleBack, setMode]);

  const handleModeSwitch = useCallback(() => {
    if (mode === "add") {
      setMode("view");
    } else if (mode === "view") {
      setMode("add");
    }
  }, [mode]);

  const leftButtons = useMemo(
    () => [
      {
        button_label: "Back",
        button_handeler: handleBackAndSetMode,
        button_key: "F12",
      },
      ...(mode === "add"
        ? [
            {
              button_label: "View Note",
              button_handeler: handleModeSwitch,
              button_key: "F6",
            },
          ]
        : []),
    ],
    [mode, handleBackAndSetMode, handleModeSwitch]
  );

  const rightButtons = useMemo(
    () => [
      ...(mode === "view"
        ? [
            {
              button_label: "Add Note",
              button_handeler: handleModeSwitch,
              button_key: "F6",
            },
          ]
        : []),
      { button_label: "Export as CSV", button_handeler: exportAsCSV },
    ],
    [mode]
  );

  const getName = (selectedAdditionalPatients, currentIndex) => (
    <>
      <strong>Schedule </strong>
      {selectedAdditionalPatients[currentIndex].apsAddtlPatPaySch}
      <span className="info-records">
        <strong> Description </strong>
        {selectedAdditionalPatients[currentIndex].apsAddtlPatpaySchDesc}
      </span>
    </>
  );

  return (
    <div className="container">
      <ButtonsSection ctaButtons={leftButtons} align="left" />
      <div className="left-aligned-section">
        <div className="header-section">
          <h1>
            {screen_title} - <span className="heading-cod">{screen_code}</span>
          </h1>
        </div>
        <p className="head-name">
          {getName(selectedAdditionalPatients, currentIndex)}
        </p>
      </div>
      <div className="button-sections">
        <ButtonsSection ctaButtons={rightButtons} align="right" />
      </div>
      <NoteTable
        data={notes}
        columns={columns}
        mode={mode}
        maxLength={55}
        newNotes={newNotes}
        handleChangeNewNote={handleChangeNewNote}
        handleSaveNotes={handleSaveNotes}
      />
      <NextGenPaginator
        first={first}
        rows={rows}
        totalRecords={totalRecords}
        currentPage={first / rows}
        rowsPerPageOptions={[10, 25, 50]}
        onPageChange={onPageChange}
      />
    </div>
  );
};

export default AdditionalPatientPayNotes;
